module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("molecules")]), _vm._v(" "), _c('h2', [_vm._v("buttons")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-16-lg"
  }, [_c('nav-button', {
    attrs: {
      "type": "next"
    }
  }, [_vm._v("next")]), _vm._v(" "), _c('nav-button', {
    attrs: {
      "type": "back"
    }
  }, [_vm._v("back")]), _vm._v(" "), _c('nav-button', {
    attrs: {
      "type": "share"
    }
  }, [_vm._v("share")]), _vm._v(" "), _c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": "call-to-action"
    }
  }, [_vm._v("begin")]), _vm._v(" "), _c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": "button-disabled"
    }
  }, [_vm._v("submit")])], 1)]), _vm._v(" "), _c('h2', [_vm._v("card with rollover")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('rollover-card', {
    attrs: {
      "spanclass": "span-4-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs",
      "ratioclass": "ratio-flip-card"
    }
  }, [_vm._v("content here")])], 1), _vm._v(" "), _c('h2', [_vm._v("Card with 3D flip effect and rollover")]), _vm._v(" "), _c('p', [_vm._v("(click to rotate)")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('flip-card', {
    attrs: {
      "icon": "culture"
    }
  }), _vm._v(" "), _c('flip-card', {
    attrs: {
      "icon": "role-models"
    }
  }), _vm._v(" "), _c('flip-card', {
    attrs: {
      "icon": "networks"
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("progress selectors (click in order)")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-9-lg offset-1-lg span-8-md overflow-hidden"
  }, [_c('progress-selector', [_vm._v("first")]), _vm._v(" "), _c('progress-selector', [_vm._v("second")]), _vm._v(" "), _c('progress-selector', [_vm._v("third")]), _vm._v(" "), _c('progress-selector', [_vm._v("fourth")])], 1)]), _vm._v(" "), _c('h2', [_vm._v("popup notification")]), _vm._v(" "), _c('h3', [_vm._v("correct")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('popup-notification', {
    attrs: {
      "type": "correct",
      "title": "you've got it!"
    }
  }, [_vm._v(_vm._s(_vm.popup_text))])], 1), _vm._v(" "), _c('h3', [_vm._v("incorrect")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('popup-notification', {
    attrs: {
      "type": "incorrect",
      "title": "not quite"
    }
  }, [_vm._v(_vm._s(_vm.popup_text))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08203295"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/style_guide/molecules.vue
// module id = 592
// module chunks = 1